var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 18,
    viewBox: "0 0 9 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.200043 16.92C0.200043 16.73 0.270044 16.54 0.420043 16.39L6.94004 9.87C7.42004 9.39 7.42004 8.61 6.94004 8.13L0.420044 1.61C0.130044 1.32 0.130044 0.84 0.420044 0.55C0.710044 0.26 1.19004 0.26 1.48004 0.55L8.00004 7.07C9.06004 8.13 9.06004 9.86 8.00004 10.93L1.48004 17.45C1.19004 17.74 0.710043 17.74 0.420043 17.45C0.280043 17.3 0.200043 17.11 0.200043 16.92Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.f27cd51023686e56c031b411e5c77a6d.svg";
export { ForwardRef as ReactComponent };